import React from 'react';
import AdminReportsList from '../../../sections/AdminDashboard/Reports/AdminReportsList';

const AdminReports = () => <AdminReportsList />;

export default AdminReports;
